import clsx from "clsx";
import { useState, FC, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import { Box, Button, Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { MyTextField } from "../../custom/MyTextField";
import { CommunicationChannelsList } from "../../../enums/enums";
import { IUserCorrespondence } from "../../../interfaces/Correspondence";
import { IUserForm } from "../../../module/admin/form/IUsersForm";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useStyles } from "../../../shared/styles/useStyles";
import { Form, Formik, FormikHelpers } from "formik";
import { ITrdProductionOffices } from "../../../redux/types/types";

interface Props {
  onSearch(data: any): void;
  module: { type: string; rol: string };
}

export interface ISelectForm {
  id: string;
  name: string;
}

export const CorrespondenceStatisticsForm: FC<Props> = ({
  onSearch,
  module,
}) => {
  const classes = useStyles();
  const { productionOffices } = useSelector((state: AppState) => state.trd);
  const { users } = useSelector((state: AppState) => state.users);
  const { office } = useSelector((state: AppState) => state.documentManagment);
  const [optionUser, setOptionUser] = useState<{ id: string; name: string }[]>(
    []
  );

  const [comunication, setComunication] = useState<{ value: string; name: string }[]>(
    [ { value: "Todos", name: "All" },]
  );


  const [disabledOffice, setDisabledOffice] = useState(false);
  const { latestProductionOffices } = useSelector((state: AppState) => state.trd);

  const [productionOfficesForm, setProductionOfficesForm] = useState<
    ISelectForm[]
  >([]);

  const intl = useIntl();
  const [officeState, setOfficerState] = useState<any | null>(null);

  const initialValues = {
    office: { id: "", name: "" },
    officerUser: { id: "", name: "" },
    startDate: new Date().toLocaleDateString("en-CA"),
    endDate: new Date().toLocaleDateString("en-CA"),
    channel: { id: "", name: "" },
  };

  const getUsers = (idOffice: string) => {
    const arrayUsers: IUserCorrespondence[] = [{ id: "0", name: "Todos" }];
    users.forEach((user: IUserForm) => {
      arrayUsers.push({
        id: user.id.toString(),
        name:
          user.firstName +
          " " +
          user.secondName +
          " " +
          user.firstLastName +
          " " +
          user.secondLastName,
      });
    });
    setOptionUser(arrayUsers);
  };

  const getOptionLabelTranslation = (option: any) => {
    return intl.formatMessage({ id: option.name });
  };

  const getOptionLabel = (option: any) => {
    return option.name;
  };

  const getProductionOfficesForm = () => {
    const data: ISelectForm[] = [{ id: "0", name: "Todos" }];
    productionOffices.forEach((dataLoad: ITrdProductionOffices) => {
      data.push({
        id: dataLoad.id.toString(),
        name: dataLoad.name,
      });
    });
    setProductionOfficesForm(data);
  };

  const getLastedProductionOfficesForm = () => {
    const data: ISelectForm[] = [{ id: "0", name: "Todos" }];
    latestProductionOffices.forEach((dataLoad: ITrdProductionOffices) => {
      data.push({
        id: dataLoad.id.toString(),
        name: dataLoad.name,
      });
    });
    setProductionOfficesForm(data);
  };

  useEffect(() => {
    setComunication([...comunication, ...CommunicationChannelsList] )
  }, []);

  useEffect(() => {
    // getProductionOfficesForm();
    getLastedProductionOfficesForm();
  }, [latestProductionOffices]);

  useEffect(() => {
    if (office && users) {
      getUsers(office.id);
      setOfficerState(null);
    }
    if (office && module.type == "management") {
      const index = latestProductionOffices.findIndex(
        (item) => item.id === office.id
      );
      setOfficerState(latestProductionOffices[index]);
      setDisabledOffice(true);
    }
  }, [office]);

  const handleSubmit = async (
    values: any,
    { setSubmitting }: FormikHelpers<any>
  ) => {
    if (disabledOffice) {
      values.office = {
        id: officeState?.id,
        name: officeState?.name,
      };
    }

    setSubmitting(true);
    onSearch(values);
    setSubmitting(false);
  };

  return (
    <Box mt={1} mb={3}>
      <Formik
        validateOnChange={true}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {({ handleChange, setFieldValue }) => (
          <Form className={classes.input}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <FormattedMessage id="SelectProductionOffice" />:
                <Autocomplete
                  id="combo-box-demo"
                  options={productionOfficesForm}
                  getOptionLabel={getOptionLabel}
                  value={officeState}
                  disabled={disabledOffice}
                  onChange={(event, newValue) => {
                    setOfficerState(newValue);
                    setFieldValue("office", {
                      id: newValue?.id,
                      name: newValue?.name,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="offices"
                      size="small"
                      variant="outlined"
                      required
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="SelectOfficer" />
                <Autocomplete
                  id="combo-box-demo"
                  options={optionUser}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, newValue) => {
                    setFieldValue("officerUser", newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="addressee"
                      size="small"
                      variant="outlined"
                      required
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="Channel" />
                <Autocomplete
                  id="combo-box-demo"
                  options={comunication}
                  getOptionLabel={getOptionLabelTranslation}
                  onChange={(event, newValue) => {
                    let name = intl.formatMessage({ id: newValue?.name });
                    setFieldValue("channel", {
                      id: newValue?.value,
                      name: name,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="outlined"
                      required
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="From" />
                <MyTextField
                  name="startDate"
                  variant="outlined"
                  type="date"
                  onChange={handleChange}
                  className={classes.myTextDate}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormattedMessage id="To" />
                <MyTextField
                  name="endDate"
                  variant="outlined"
                  type="date"
                  onChange={handleChange}
                  className={classes.myTextDate}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={4}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  className={clsx(classes.btnAction, classes.save)}
                  autoFocus
                  type="submit"
                  style={{ marginTop: "21px", width: "200px", height: "37px" }}
                >
                  <FormattedMessage id="Search" />
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
